import * as Scrivito from "scrivito";

function FooterContent({ page }) {
  if (page.objClass() !== "Homepage") {
    return null;
  }
  return (
    <div className="bg-light-gray foter-content">
      <div className="container">
        <Scrivito.ContentTag
          content={page}
          attribute="footerContent"
          tag="div"
        />
      </div>
    </div>
  );
}

export default Scrivito.connect(FooterContent);
